import { createMuiTheme } from '@material-ui/core/styles';
import blueGrey from '@material-ui/core/colors/blueGrey';

export const theme = createMuiTheme({
  palette: {
    primary: blueGrey,
  },
});
